import { useBoolean, usePagination, useToastr } from "@laxmimanogna/code-quick-components";
import { createContext, useState } from "react";
import { SELF } from "../constants/constants";
import dashboardRepository from "../repositories/DashboardRepository";
import myChartRepository from "../repositories/MyChartRepository";

export const MyChartContext = createContext({
    getAllCharts: async () => { },
    getArchivedCharts: async () => { },
    getRebuttedCharts: async () => { },

    allCharts: [],
    archivedCharts: [],
    rebuttedCharts: [],

    filterParams: {},
    handleApplyFilter: () => { },
    isAllChartLoading: false,
    isArchivedChartLoading: false,
    isRebuttedChartLoading: false,
    getFileObjectByBatchId: async () => { },
    isFileLoading: false
});
const initialFilterParams = {
    searchText: ''
}

const MyChartProvider = props => {
    const toast = useToastr();

    const [allCharts, setAllCharts] = useState([])
    const [archivedCharts, setArchivedCharts] = useState([])
    const [rebuttedCharts, setRebuttedCharts] = useState([])
    const [isAllChartLoading, ialState] = useBoolean(false)
    const [isArchivedChartLoading, iarState] = useBoolean(false)
    const [isRebuttedChartLoading, irState] = useBoolean(false)
    const [isFileLoading, iflState] = useBoolean(false)

    const [filterParams, setFilterParams] = useState(
        Object.assign({}, initialFilterParams)
    );

    const getFilterParams = () => {
        const queryParams = {};
        const { searchText } = filterParams;
        if (searchText) queryParams['search'] = searchText;

        return queryParams;
    };

    const handleApplyFilter = selectedFilters => {
        setFilterParams(selectedFilters);
    };

    const getAllCharts = async (paginationParams) => {
        const filterParams = getFilterParams();
        filterParams['user'] = SELF
        ialState.on()
        try {
            const response = await myChartRepository.getCharts({ ...filterParams, ...paginationParams })
            const annotatedResponse = response.results.map(val => ({...val, batch_providers: [...new Set(val.subRows.map(row => (row.providers ?? []).map(chartProv => chartProv.name)).flat().filter(name => !!name))]}))
            setAllCharts(annotatedResponse)
            return {...response, results: annotatedResponse};
        } catch (err) {
            toast.showError({
                description: `Something went wrong`,
            });
        } finally {
            ialState.off()
        }
    }
    const getArchivedCharts = async (paginationParams) => {
        const filterParams = getFilterParams();
        filterParams['status'] = 'RECEIVED'
        filterParams['user'] = SELF
        iarState.on()
        try {
            const response = await myChartRepository.getCharts({ ...filterParams, ...paginationParams })
            const annotatedResponse = response.results.map(val => ({...val, batch_providers: [...new Set(val.subRows.map(row => (row.providers ?? []).map(chartProv => chartProv.name)).flat().filter(name => !!name))]}));
            setArchivedCharts(annotatedResponse)
            return { ...response, results: annotatedResponse, count: response.results.length }
        } catch (err) {
            toast.showError({
                description: `Something went wrong`,
            });
        } finally {
            iarState.off()
        }
    }

    const getRebuttedCharts = async (paginationParams) => {
        const filterParams = getFilterParams();
        filterParams['status'] = 'rebuttal'
        filterParams['user'] = SELF
        irState.on()
        try {
            const response = await myChartRepository.getCharts({ ...filterParams, ...paginationParams })
            const annotatedResponse = response.results.map(val => ({...val, batch_providers: [...new Set(val.subRows.map(row => (row.providers ?? []).map(chartProv => chartProv.name)).flat().filter(name => !!name))]}))
            setRebuttedCharts(annotatedResponse)
            return { ...response, results: annotatedResponse }
        } catch (err) {
            toast.showError({
                description: `Something went wrong`,
            });
        } finally {
            irState.off()
        }
    }

    const getFileObjectByBatchId = async (batchId) => {
        try {
            iflState.on();
            const response = await dashboardRepository.getFileObjectByBatchId(batchId);
            return response;
        } catch (err) {
            toast.showError({
                description: `Something went wrong.`,
            });
        } finally {
            iflState.off();
        }
    }
    const getAllCharts1 = usePagination(getAllCharts)
    const getArchivedCharts1 = usePagination(getArchivedCharts)
    const getRebuttedCharts1 = usePagination(getRebuttedCharts)


    const mContext = {
        getAllCharts: getAllCharts1,
        getArchivedCharts: getArchivedCharts1,
        getRebuttedCharts: getRebuttedCharts1,

        allCharts,
        archivedCharts,
        rebuttedCharts,
        filterParams,
        handleApplyFilter,
        isAllChartLoading,
        isArchivedChartLoading,
        isRebuttedChartLoading,
        getFileObjectByBatchId,
        isFileLoading
    };

    return (
        <MyChartContext.Provider value={mContext}>
            {props.children}
        </MyChartContext.Provider>
    );
};

export default MyChartProvider;
